"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.MessageText=exports.MessageBarContainer=exports.CloseButton=void 0;const MessageBarContainer=exports.MessageBarContainer=_styledComponents.default.div`
    background-color: #EBF3F9; /* Light blue background */
    color: #212529; /* Dark text color */
    padding: 10px 15px;
    border: 1px solid #dee2e6; /* Border color */
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`,MessageText=exports.MessageText=_styledComponents.default.span`
    flex: 1;
    margin-right: 10px;
    font-family: pds/global/font/family/nunito_sans;
    font-weight: 600;
    font-size: 200;
    line-height: 145%;
    letter-spacing: 0%;
    text-align: center;
`,CloseButton=exports.CloseButton=_styledComponents.default.button`
    background: none;
    border: none;
    color: #007bff; /* Blue color for the close button */
    cursor: pointer;
    font-size: 14px;
    padding: 0;

    &:hover {
        text-decoration: underline;
    }
`;